export const TypeAngles = {
    "Tipo A1 Torre E":  0,
    "Tipo B1 Torre D":  0,
    "Tipo C1 Torre D":  40,
    "Tipo D1 Torre D":  80,
    "Tipo A Torre D":  0,
    "Tipo B Torre D":  0,
    "Tipo D Torre D":  50,
    "Tipo A Torre E":  70,
    "Tipo B Torre E":  50,
    "Tipo C Torre E":  0,
    "Tipo D Torre E":  0,
}